import { useMemo } from 'react';

import { selectors, useAppSelector } from '@fhs-legacy/frontend/src/state/global-state';
import { useFlag } from '@fhs-legacy/frontend/src/utils/launchdarkly';

import { useRewardTiers } from '../queries/loyalty.queries';

export const useRewardTierApplied = () => {
  const isRewardsTiersEnabled = useFlag('enable-rewards-tiers')

  const { data: rewardTiers, isFetched } = useRewardTiers();
  const appliedOffers = useAppSelector(selectors.loyalty.selectAppliedOffers);

  const rewardTierApplied = useMemo(() => {
    return rewardTiers?.find(tier => appliedOffers.some(offer => offer.id === tier.id));
  }, [rewardTiers, appliedOffers]);

  return {
    rewardTierApplied,
    isRewardTierApplied: !!rewardTierApplied,
    isFetched,
    isRewardsTiersEnabled,
  };
};
